import { render } from "./ContantCard.vue?vue&type=template&id=3069cd01&scoped=true"
import script from "./ContantCard.vue?vue&type=script&lang=js"
export * from "./ContantCard.vue?vue&type=script&lang=js"

import "./ContantCard.vue?vue&type=style&index=0&id=3069cd01&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3069cd01"]])

export default __exports__